import { render, staticRenderFns } from "./Payment-succes-screen.vue?vue&type=template&id=5cf96d6e&scoped=true&"
import script from "./Payment-succes-screen.vue?vue&type=script&lang=js&"
export * from "./Payment-succes-screen.vue?vue&type=script&lang=js&"
import style0 from "./Payment-succes-screen.vue?vue&type=style&index=0&id=5cf96d6e&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5cf96d6e",
  null
  
)

export default component.exports